import { TprmRequirementType } from '../../models/entity-details';

export function toTprmRequirementType(value: string): TprmRequirementType {
    return value as TprmRequirementType;
}
